import * as yup from 'yup';

// Phone is validated separately because it depends on the selected country code
const RegisterValidations = yup.object().shape({
    firstName: yup.string().trim().required('Enter your first name.').max(30),
    lastName: yup.string().trim().required('Enter your last name.').max(30),
    email: yup.string().trim().required('Enter your email.').email('Enter a valid email address.'),
    password: yup.string()
        .required('Create a password.')
        .min(8, 'Use at least 8 characters.')
        .matches(/[A-Za-z]/, 'Include at least one letter.')
        .matches(/\d/, 'Include at least one number.'),
    terms: yup.boolean().oneOf([true], 'Please accept the terms to continue.')
});

export default RegisterValidations;
